// Shared helpers for the Shipments UI.
import { api } from './api';

export const RAG_META = {
  red:     { label: 'Late',     chip: 'bg-red-600 text-white',      dot: 'bg-red-600' },
  amber:   { label: 'Tight',    chip: 'bg-amber-500 text-white',    dot: 'bg-amber-500' },
  green:   { label: 'On track', chip: 'bg-green-600 text-white',    dot: 'bg-green-600' },
  done:    { label: 'Delivered', chip: 'bg-slate-600 text-white',   dot: 'bg-slate-500' },
  unknown: { label: 'No need-by date', chip: 'bg-gray-200 text-gray-700 dark:bg-slate-700 dark:text-slate-200', dot: 'bg-gray-400' },
};

export const CONTACT_ROLE_LABEL = {
  customer_pm: 'Customer PM', gc_pm: 'GC PM', site_contact: 'Site contact', installer: 'Installer',
  partner: 'Partner', concria: 'Concria', forwarder: 'Forwarder', broker: 'Customs broker',
  warehouse: 'Warehouse (Pinnacle)', other: 'Other',
};

export const AUDIENCE_LABEL = { customer: 'Customer / GC', installer: 'Installer', partners: 'Partners digest', concria: 'Concria weekly' };

let metaPromise = null;
export function loadMeta() {
  if (!metaPromise) metaPromise = api.get('/shipments/meta').catch((e) => { metaPromise = null; throw e; });
  return metaPromise;
}

// 'YYYY-MM-DD' or ISO → "Thu, Oct 22"
export function fmtDay(d) {
  if (!d) return '—';
  const x = new Date(`${String(d).slice(0, 10)}T12:00:00Z`);
  if (Number.isNaN(x.getTime())) return '—';
  return x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

export function fmtWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function slackText(schedule) {
  if (!schedule) return '';
  if (schedule.rag === 'done') return schedule.slack_days != null ? `${schedule.slack_days >= 0 ? `${schedule.slack_days} d early` : `${-schedule.slack_days} d late`}` : 'delivered';
  if (schedule.slack_days == null) return 'set a need-by date';
  const s = schedule.slack_days;
  return s < 0 ? `${-s} d late` : s === 0 ? '0 d slack' : `${s} d slack`;
}

export function RagChip({ schedule, big = false }) {
  const meta = RAG_META[schedule?.rag || 'unknown'];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold ${meta.chip} ${big ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-[11px]'}`}>
      {meta.label}{schedule && schedule.rag !== 'unknown' ? ` · ${slackText(schedule)}` : ''}
    </span>
  );
}
